import { THeaderFilterGroup } from '@shared/components/dx-data-grid/feature';
import { contractStatusAttrOnMap } from './contracts.map';
import { getJSDate } from '@shared/utils';

/** Single result returned by `GET /ContractsSign/GetResultsContractsNotSents`: a contract that could not be sent, with the reason in `StatusNotSend`. */
export interface IContractNotSentResult {
  ResultContractSentId: string;
  EventId: string;
  ContractId: string;
  PersonId: string;
  SignerFullName: string;
  StatusNotSend: string;
}

export const selectContractFields = [
    'PersonId',
    'ModelId',
    'StorageObjectId',
    'ReasonOfClosed',
    'CreatedByFullName',
    'ModelDescription',
    'LinkToSignGeneratedOn',
    'SignedOn',
    'thumbStorageId',
    'WitnessOnePersonId',
    'WitnessTwoPersonId',
    'SuretyPersonId',
    'ExpiredOn',
    'ClosedOn',
    'EmailSentOn',
    'Status',
    'Description',
    'AddedOn',
    'ContractId',
    'SignerFullName',
    'SignerSignedOn',
    'CompanySignerFullName',
    'CompanySignedOn',
    'WitnessOneSignerFullName',
    'WitnessOneSignedOn',
    'WitnessTwoSignerFullName',
    'WitnessTwoSignedOn',
    'SuretyFullName',
    'EndorsedOn',
    'SignUrl',
    'StartedOn',
    'IntegratorContractKey',
    'IntegratorRequestSignatureKey',
    'IntegratorRequestCompanyKey',
    'IntegratorRequestSuretyKey',
    'IntegratorRequestWitnessOneKey',
    'IntegratorRequestWitnessTwoKey',
    'DeadlineOn',
    'FinishedOn',
    'SigningOn',
    'IsPersonActive',
    'SubscriptionPersonDescription',
].join(',');

export const contractsHeaderFilterGroups: THeaderFilterGroup[] = [
    {
        title: 'CONTRACTS.STATUS',
        column: 'Status',
        filterComponent: 'dropdown',
        externalDataGridFilter: true,
        options: [
            { id: '1', description: 'CONTRACTS.STATUS_FILTER.SIGNED', value: 'signed' },
            { id: '2', description: 'CONTRACTS.STATUS_FILTER.SIGNING', value: 'signing', customFilter: ['Status', 'contains', 'signing'] },
            { id: '3', description: 'CONTRACTS.STATUS_FILTER.CLOSED', value: 'closed' },
            { id: '4', description: 'CONTRACTS.STATUS_FILTER.EXPIRED', value: 'expired' },
            { id: '5', description: 'CONTRACTS.STATUS_FILTER.ADDED', value: 'added' },
            { id: '6', description: 'CONTRACTS.STATUS_FILTER.GENERATED_LINK', value: 'linktosigngenerated', customFilter: [['Status', '=', 'linktosigngenerated'], 'or', ['Status', '=', 'emailtosignsent']] },
            { id: '7', description: 'CONTRACTS.STATUS_FILTER.DECLINED', value: 'declined', customFilter: ['Status', 'contains', 'declined'] },
        ]
    },
    {
        title: 'CONTRACTS.SIGNED_DATE',
        column: 'date',
        filterComponent: 'dateRange',
        externalDataGridFilter: true
    }
]

export const getSelectedFiltersExpr = (selectedFilters: Record<string, any>): any[] => {
    return Object.values(selectedFilters || {})?.map((f) => {

        if (f.value?.customFilter) return f.value.customFilter;

        if (f.column === 'date') {
            const status = selectedFilters['Status']?.value?.value;

            if (status) {
                const attr = contractStatusAttrOnMap.get(status);
                return [[attr, '>=', getJSDate(f.value.start)], 'and', [attr, '<=', getJSDate(f.value.end)]];
            }

            const filterDates = [];

            for (const attr of contractStatusAttrOnMap.values()) {
                if (filterDates.length) filterDates.push('or');
                filterDates.push([[attr, '>=', getJSDate(f.value.start)], 'and', [attr, '<=', getJSDate(f.value.end)]]);
            }

            return filterDates;
        }

        return [f.column, '=', f.value?.value];
    });
}